import { useState } from 'react';
import LoadingContainer from 'src/componentes/loading-container';
import Pagination from 'src/componentes/list/pagination';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import { useIntl } from 'react-intl';
import { capitalizeFirstLetter } from 'src/utils/string';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

const SecaoPessoal = ({ isLoading = false, colaborador }) => {
  const intl = useIntl();

  const isVisible = (campoId) => {
    const campos = colaborador?.campos;

    if (campos) {
      const campo = campos.find((c) => c.campoId === campoId);
      return campo.visivel;
    }

    return true;
  };

  return (
    <div className="border rounded-lg p-4 mb-4 shadow">
      <LoadingContainer isLoading={isLoading}>
        <div className="d-flex text-primary">
          <UserCircleIcon
            style={{ width: '20px', marginBottom: '12px' }}
            className="mr-2"
          />
          <div className="text-primary text-base font-weight-bold mb-2 text-xl">
            {capitalizeFirstLetter(intl.formatMessage({ id: 'pessoal' }))}
          </div>
        </div>
        {!isLoading && (
          <div className="mt-2">
            {isVisible(COLABORADOR_CAMPOS.GENERO) && (
              <>
                <div className="text-lg font-weight-bolder mb">
                  {intl.formatMessage({ id: 'genero' })}
                </div>

                <div>
                  {colaborador?.genero?.descricao ||
                    intl.formatMessage({ id: 'naoInformado' })}
                </div>
                <hr />
              </>
            )}
            {isVisible(COLABORADOR_CAMPOS.NOME_SOCIAL) && (
              <>
                <div className="text-lg font-weight-bolder mb">
                  {intl.formatMessage({ id: 'nomeSocial' })}
                </div>
                <div>
                  {colaborador?.nomeSocial ||
                    intl.formatMessage({ id: 'naoInformado' })}
                </div>
                <hr />
              </>
            )}
            {isVisible(COLABORADOR_CAMPOS.RACA) && (
              <>
                <div className="text-lg font-weight-bolder mb">
                  {intl.formatMessage({ id: 'raca' })}
                </div>
                <div>
                  {colaborador?.raca?.descricao ||
                    intl.formatMessage({ id: 'naoInformado' })}
                </div>
                <hr />
              </>
            )}
            {isVisible(COLABORADOR_CAMPOS.ORIENTACAO_SEXUAL) && (
              <>
                <div className="text-lg font-weight-bolder mb">
                  {intl.formatMessage({ id: 'orientacaoSexual' })}
                </div>
                <div>
                  {colaborador?.orientacaoSexual?.descricao ||
                    intl.formatMessage({ id: 'naoInformado' })}
                </div>
                <hr />
              </>
            )}
            {isVisible(COLABORADOR_CAMPOS.LINKEDIN) && (
              <>
                <div className="text-lg font-weight-bolder mb">
                  {intl.formatMessage({ id: 'LinkedIn' })}
                </div>
                <div>
                  {colaborador?.linkedIn ||
                    intl.formatMessage({ id: 'naoInformado' })}
                </div>
              </>
            )}
          </div>
        )}
      </LoadingContainer>
    </div>
  );
};

export default SecaoPessoal;
